<template>
  <div>
    <div class="mp-box" v-if="
            info.show_comments == 1 &&
              info.adv_comment &&
              info.adv_comment.type == 1
          " @click="toWebview">
      <img src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220513/81d5190d620358b9bd09c0b7c6a4cb07.svg" />
      <div class="textLeft">{{ info.adv_comment.title }}</div>
    </div>

    <div class="comment-text" :class="{'text-left':  info.comment.length > 70, 'answer': info.is_answer}" v-else-if="info.show_comments == 1 && (info.adv_comment.content || info.adv_comment.img)">
      <span>{{ info.adv_comment.content }}</span>
      <img :class="info.adv_comment.content ? 'mt15' : ''" @click="showPic(info.adv_comment.img)" :src="info.adv_comment.img" v-if="info.adv_comment.img" />
    </div>
  </div>
</template>

<script>
import { ImagePreview } from "vant";
export default {
  props: {
    info: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {

    };
  },
  methods: {
    showPic(val) {
      ImagePreview({
        images: [val],
        showIndex: false,
        loop: false,
        startPosition: 0
      });
    },
    // 评论跳转至公众号
    toWebview() {
      let url = this.info.adv_comment.url;
      if (url) {
        window.location.href = this.info.adv_comment.url;
      }
    },

  }
};
</script>
<style lang="scss" scoped>
@function rem($px) {
  @return $px * 2 / 75 + rem;
}
.mp-box {
  display: flex;
  align-items: center;
  font-size: 14px;
  columns: #666;
  margin: 15px 0 0;
  padding: 10px;
  background-color: #f5f5f5;
}
.textLeft {
  text-align: left ;
}
.mp-box img {
  width: 45px;
  height: 45px;
  margin-right: 10px;
  object-fit: cover;
}
.mp-box view {
  flex: 1;
  line-height: 1.5;
  text-align: left;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.comment-text {
  margin: 15px 0 0;
  background-color: #f5f5f5;
  padding: 15px;
  font-size: 15px;
  line-height: 1.5;
  border-radius: 5px;
  color: #262626;
  white-space: pre-line;
}
.comment-text.answer {
  background: #ffffff;
  padding: 0
}
.comment-text text {
  max-width: 100%;
}
.comment-text img {
  display: block;
  margin: 0 auto;
  width: 100%;
  object-fit: cover;
}
.comment-text.mb15 {
  margin-bottom: 15px;
}
.mt15 {
  margin-top: 15px !important;
}
.text-left{
  text-align: left !important;
}
</style>



// WEBPACK FOOTER //
// src/components/mpBox.vue